const Notification = () => {
  return (
    <div>
      <header className="flex items-center justify-between">
        <div>
          <p className="text-lg">My Account</p>
          <p className="text-3xl leading-6 font-bold">Notification</p>
        </div>
      </header>

      <div className="mt-8 rounded-xl bg-white p-4 *:not-last-of-type:border-b *:not-last-of-type:pb-4">
        <div className="flex items-center justify-center text-lg font-semibold">
          No Notifications yet
        </div>
        {/* {[1, 2, 3].map((index) => (
          <div key={index}>
            <h4 className="text-base leading-4 font-medium lg:text-lg">
              Card BIN channel maintenance extension notice
            </h4>
            <p className="text-primary-500/50 text-sm leading-4 lg:text-lg lg:leading-6">
              We have received a notice from the bank that the bank needs to
              adjust the suspicious transactions of some cards, so the following
              card maintenance period will be extended: Card BIN: 5157, 4866,
              5329 It is expected to end this week. If the channel maintenance
              ends ahead of schedule, we will notify you separately. If you have
              any questions or need help, please feel free to contact your
              account manager or online customer service. Sorry for the
              inconvenience.
            </p>
            <p className="text-primary-500/50 text-right">12/01/2023</p>
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default Notification;
